import axios from 'axios';
import { createApp } from 'vue';
axios.interceptors.request.use(
	config => {
        var token = document.querySelector('meta[name="csrf-token"]').content
		config.headers['X-CSRF-Token'] = token;
		return config
	},
	error => Promise.reject(error)
);

import plotly from 'plotly.js-dist';
window.plotly = plotly;

import _ from 'lodash';
window._ = _;

import { createPinia } from 'pinia';
const pinia = createPinia();

import DeliveryPage from '@/DeliveryPage.vue';
import PrintDelivery from '@/print/PrintDelivery.vue';
import PrintDeliveryOverview from '@/print/PrintDeliveryOverview.vue';
import PrintWarmList from '@/print/PrintWarmList.vue';
import PrintBreadList from '@/print/PrintBreadList.vue';
import ProductBoxCount from '@/ProductBoxCount.vue';
import PrintPickUpDeliveries from '@/print/PrintPickUpDeliveries.vue';
import StatusLabel from '@/components/StatusLabel.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import BookingGuideEditor from '@/BookingGuideEditor.vue';
import BookingGuideModal from '@/components/BookingGuideModal.vue';
import SettingWysiwygEditor from '@/SettingWysiwygEditor.vue';

export default () => {
    document.addEventListener('DOMContentLoaded', () => {
        const containers = document.getElementsByClassName('vue-app');
        for(let i=0;i<containers.length;i++) {
            const app = createApp({})
            app.component('product-box-count', ProductBoxCount);
            app.component('delivery-page', DeliveryPage);
            app.component('print-delivery', PrintDelivery);
            app.component('print-warm-list', PrintWarmList);
            app.component('print-delivery-overview', PrintDeliveryOverview);
            app.component('print-bread-list', PrintBreadList);
            app.component('print-pick-up-deliveries', PrintPickUpDeliveries);
            app.component('status-label', StatusLabel);
            app.component('status-indicator', StatusIndicator);
            app.component('booking-guide-editor', BookingGuideEditor);
            app.component('booking-guide-modal', BookingGuideModal);
            app.component('setting-wysiwyg-editor', SettingWysiwygEditor);
            app.use(pinia);
            app.mount(containers[i]);
        }
    })
}